import script from "./AdminCases.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCases.vue?vue&type=script&setup=true&lang=js"

import "./AdminCases.vue?vue&type=style&index=0&id=bfc7d542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfc7d542"]])

export default __exports__